<template>
  <q-page padding class="text-center">
    <h2>Xero Access</h2>

    <div v-if="hasXeroAccess && !$apollo.loading">
      <div v-if="xeroConnected">
        <div class="q-pb-md">Connected to Xero!</div>
        <q-btn @click="disconnect">Disconnect</q-btn>
      </div>
      <q-btn v-else @click="connect">Connect to Xero</q-btn>
    </div>
  </q-page>
</template>

<script>
import gql from 'graphql-tag'
import saveAs from 'file-saver'

export default {
  name: 'PageAdminXero',
  apollo: {
    xeroConnected () {
      return {
        query: gql`
          query {
            xeroConnected
          }`,
        fetchPolicy: 'network-only'
      }
    }
  },
  computed: {
    hasXeroAccess () {
      return this.currentAccount && this.currentAccount.roles.includes('xeroAccess')
    },
    currentAccount () {
      return this.$store.state.auth.currentAccount
    }
  },
  methods: {
    disconnect () {
      this.$q.dialog({
        title: 'Disconnect Xero',
        message: `Are you sure you want to disconnect Xero?`,
        cancel: true
      }).onOk(() => {
        this.disconnectWithoutAsking()
      })
    },
    async disconnectWithoutAsking () {
      await this.$apollo.mutate({
        mutation: gql`mutation disconnectXero {
          disconnectXero
        }`
      })
      this.xeroConnected = false
    },
    async connect () {
      const link = await this.$apollo.query({
        query: gql`query getXeroConnectionLink {
          getXeroConnectionLink
        }`,
        fetchPolicy: 'network-only'
      })
      const connectWindow = window.open(link.data.getXeroConnectionLink, 'Connect ICP to Xero', 'width=500,height=600')
      this.$apollo.queries.xeroConnected.startPolling(1000)
      while (true) {
        if (this.xeroConnected) break
        if (connectWindow.closed) break
        await new Promise(resolve => setTimeout(resolve, 10))
      }
      connectWindow.close()
      this.$apollo.queries.xeroConnected.stopPolling()
    },
    async downloadProductsCSV () {
      const result = await this.$apollo.query({
        query: gql`query productsCsv {
          productsCsv
        }`,
        fetchPolicy: 'network-only'
      })
      saveAs(new Blob([result.data.productsCsv], { type: 'application/octet-stream' }), `ICP_Products.csv`)
    }
  },
  data () {
    return {
      xeroConnected: null,
      xeroConnectUrl: (process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql').replace('graphql', 'connect')
    }
  }
}
</script>
